import React from "react";
import MailCheck from "react-mailcheck";
import PropTypes from "prop-types";
import {
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  FormGroup,
} from "reactstrap";
import { FieldShell, FieldError } from "../Inputs/FieldShell";
import { EmailPillWrap } from "./styled";

const MailCheckInput = ({
  inputText,
  handleEmailChange,
  children,
  useInputAddon,
}) => (
  <MailCheck
    email={inputText}
    domains={[
      "yahoo.com",
      "gmail.com",
      "hotmail.com",
      "comcast.net",
      "att.net",
      "aol.com",
      "outlook.com",
    ]}
    topLevelDomains={["com", "net"]}
  >
    {(suggestion) => (
      <FormGroup>
        {useInputAddon ? (
          <EmailPillWrap>
            <InputGroup className="form-group-no-border">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="nc-icon nc-email-85" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Email address"
                type="email"
                onChange={handleEmailChange}
                value={inputText}
                aria-label="Email address"
              />
            </InputGroup>
          </EmailPillWrap>
        ) : (
          <FieldShell>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>Email</InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Email"
                type="email"
                onChange={handleEmailChange}
                value={inputText}
                aria-label="Email address"
              />
            </InputGroup>
          </FieldShell>
        )}
        {suggestion && (
          <FieldError>Did you mean {suggestion.full}?</FieldError>
        )}
        {children}
      </FormGroup>
    )}
  </MailCheck>
);

MailCheckInput.propTypes = {
  inputText: PropTypes.string,
  handleEmailChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  useInputAddon: PropTypes.bool,
};

MailCheckInput.defaultProps = {
  useInputAddon: true,
};

export default MailCheckInput;
